const contentSectionHeaders = document.querySelectorAll('.post-content h2, .post-content h3');

    // Loop through the selected elements
    contentSectionHeaders.forEach(header => {
      const getContent = header.innerHTML.toLowerCase().replace(/\s+/g, '-');
      header.setAttribute('id', getContent);
    });

    document.addEventListener('DOMContentLoaded', function() {
      tocbot.init({
        tocSelector: '.toc',
        contentSelector: '.post-content',
        headingSelector: 'h2, h3',
      });
      const elementSubscribe = document.querySelector('a[href="#this-post-is-for-paying-subscribers-only"]');
      if(elementSubscribe){
        const elementSubscribeParent = elementSubscribe.parentNode;
        elementSubscribeParent.remove();
      }
    });

    if(!hasClientTag) {
      if(topicMicrosite) {
        const breadcrumbElem = document.querySelector(".post-breadcrumb");
        breadcrumbElem.innerHTML = "";
        if(primaryTagSlug == topicMicrositeSlug) {
          breadcrumbElem.innerHTML = `<a href="/content-hub/">Content Hub</a> > <a class="active" href="/${topicMicrositeSlug}">${topicMicrositeName}</a>`;
        } else {
          breadcrumbElem.innerHTML = `<a href="/content-hub/">Content Hub</a> > <a href="/${topicMicrositeSlug}">${topicMicrositeName}</a> > <a class="active" href="/content-hub/?filter=${primaryTagSlug}">${primaryTagName}</a>`;
        }
        

        const allTopicTag = document.querySelectorAll(`.post-tag-item[tag-slug="${topicMicrositeSlug}"]`);
        if(allTopicTag){
          allTopicTag.forEach((elem) => {
            elem.setAttribute("href", `/${topicMicrositeSlug}`);
          });
        }
      }
    }

    const screenWidth = window.innerWidth;

  // function renderAds(ads) {
  //   const adsDisplay = {
  //       top: [],
  //       right: [],
  //       bottom: [],
  //   };

  //   // Get the current URL
  //   const currentUrl = window.location.href;

  //   ads.forEach((ad) => {
  //       if (ad.status === 'active') {
  //         if(ad.display_location_by == 'article'){
  //           if(ad.display_location_mode == 'specific'){
  //             const isValidLocation = ad.url === currentUrl;

  //             if (isValidLocation) {
  //                 adsDisplay[ad.display_location_screen].push(ad);
  //             }
  //           } else {
  //             adsDisplay[ad.display_location_screen].push(ad);
  //           }
  //         } else {
  //           const isValidLocation = ad.tag === primaryTag;
          
  //           if (isValidLocation) {
  //             adsDisplay[ad.display_location_screen].push(ad);
  //           }
  //         }
  //       }
  //   });

  //   // Function to get a random item from an array
  //   function getRandomItem(array) {
  //       const randomIndex = Math.floor(Math.random() * array.length);
  //       return array[randomIndex];
  //   }

  //   // Get a random item from each array
  //   const randomTopAd = getRandomItem(adsDisplay.top);
  //   const randomRightAd = getRandomItem(adsDisplay.right);
  //   const randomBottomAd = getRandomItem(adsDisplay.bottom);

  //   // Function to create an img element with a link for an ad
  //   function createImgLinkElement(ad) {
  //       const linkElement = document.createElement("a");
  //       linkElement.setAttribute("target", "_blank");
  //       linkElement.href = ad.image_url;

  //       const imgElement = document.createElement("img");
  //       if(screenWidth <= 500){
  //         imgElement.src = ad.mobile_image;
  //       }else{
  //         imgElement.src = ad.image;
  //       }
        
  //       imgElement.alt = ad.name;

  //       linkElement.appendChild(imgElement);
  //       return linkElement;
  //   }

  //   // Function to append ad to container and display it
  //   function displayAd(ad, container) {
  //       if (ad) {
  //           const adImgElement = createImgLinkElement(ad);
  //           if(container){
  //             container.appendChild(adImgElement);
  //             container.style.display = "block";
  //           }
  //       }
  //   }

    

  //   // Get the container elements by their IDs
  //   const topAdsContainer = document.getElementById("topContainer");
  //   const rightAdsContainer = document.getElementById("rightAdsContainer");
  //   const bottomAdsContainer = document.getElementById("bottomAdsContainer");
    
  //   if(disabledAds) {
  //     if(topAdsContainer) {
  //       topAdsContainer.remove();
  //     }
  //     if(rightAdsContainer) {
  //       rightAdsContainer.remove();
  //     }
  //     if(bottomAdsContainer) {
  //       bottomAdsContainer.remove();
  //     }
  //   } else {
  //     // Create img elements for each random ad and append them to their respective containers
  //     displayAd(randomTopAd, topAdsContainer);
  //     displayAd(randomRightAd, rightAdsContainer);
  //     displayAd(randomBottomAd, bottomAdsContainer);
  //   }
  // }

  // console.log("disabledAds", disabledAds);

  // Find the button with the class "get-copy-btn"
  const copyButton = document.querySelector('.get-copy-btn');
  const copyButtonMobile = document.getElementById("getCopyBtn");
  if(copyButton){
    // Clone the button
    const clonedButton = copyButton.cloneNode(true);
    
    // Find the div with the class "post-title"
    const postTitleDiv = document.querySelector('.post-title');

    // Find the element to append after
    const followUsOnLinkedin = document.querySelector('.follow-us-on-linkedin');

    // Append the new element after it
    followUsOnLinkedin.parentNode.insertBefore(clonedButton, followUsOnLinkedin.nextSibling);

    if(copyButtonMobile){
      copyButtonMobile.setAttribute("href", copyButton.getAttribute('href'));
      if (screenWidth <= 500) {
        copyButtonMobile.classList.remove('hidden');
      }
    }
    // Append the cloned button to the post-title div
    postTitleDiv.appendChild(clonedButton);

    // Remove the cloned button after appending
    copyButton.remove();
  }
  

  const postTitle = document.querySelector(".post-title h1");
  
  if(postTitle){
    // Split the text based on pipe (|)
    const splitText = postTitle.textContent.split('  ');

    if(splitText.length > 1){
      // Create new HTML elements with the split values
      const newContent = document.createElement('h1');
      newContent.innerHTML = `<span class="title">${splitText[0]}</span> <span class="sub-title text-primary-coral-gradient">${splitText[1]}</span>`;

      // Clear the existing content and append the new HTML elements
      postTitle.remove();

      const newPostTitle = document.querySelector(".post-title");
      newPostTitle.appendChild(newContent);
    }
  }
  
   

   document.querySelector('.copy-link').addEventListener('click', function() {

    // Get the current URL
     var currentUrl = window.location.href;

    // Create a temporary input element
     var tempInput = document.createElement('input');
     tempInput.value = currentUrl;

    // Append the input element to the DOM
     document.body.appendChild(tempInput);

    // Select the input element's content
     tempInput.select();
     tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected content to the clipboard
     document.execCommand('copy');

    // Remove the temporary input element
     document.body.removeChild(tempInput);

    // Show tooltip
     var tooltip = document.getElementById('tooltip');
     tooltip.style.opacity = 1;
    tooltip.style.textIndent = '1px';

    // Hide tooltip after a short delay
     setTimeout(function() {
       tooltip.style.opacity = 0;
       tooltip.style.textIndent = '-999px';
     }, 2000); // Adjust the delay as needed
   });

   const formatDate = (dateString) => {
      const postDate = new Date(dateString)

      // Define the options for formatting the date
      const dateOptions = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      // Format the date
      const formattedDate = postDate.toLocaleDateString("en-US", dateOptions);

      // Include the time difference in the result
      let result = `${formattedDate}`;

      return result;
    };
  
    async function fetchRelatedPosts() {
      const container = document.getElementById('related-content-container');

      const fetchPosts = await api.posts.browse({
        limit: 'all',
        filter: `primary_tag:${primaryTag}+id:-${postId}`,
        include: "tags,authors",
        order: `published_at desc`,
      });
      
      const prioPost = [];
      const lessPrioPost = [];

      fetchPosts.forEach((post) => {
        if(sponsored){
          const ifHasSponsored = post.tags.filter((tag) => tag.slug === sponsored);
          if(ifHasSponsored.length > 0){
            prioPost.push(post);
          } else {
            lessPrioPost.push(post);
          }
        } else {
          lessPrioPost.push(post);
        }
      });

      const mergedPost = [...prioPost, ...lessPrioPost];
      mergedPost.forEach((post, index) => {
        if(index <= 3){
          let reading_time = 1;
          if (post.reading_time >= reading_time) {
            reading_time = post.reading_time
          }
          const readTime = `${reading_time} min`;

          let featured_image = "";

          if (post.feature_image) {
            featured_image = post.feature_image;
          } else {
            featured_image = "/assets/built/no-image.jpg"
          }

          const postCardComponent = document.getElementById("postCard").innerHTML;
          
          // Create a temporary element to hold the HTML string
          const tempElement = document.createElement("div");
          tempElement.innerHTML = postCardComponent;
          
          // Access the image element within the temporary element
          const imageElement = tempElement.querySelector(".post-card-image");
          imageElement.src = featured_image;

          // Access the links element within the temporary element
          const postCardLink = tempElement.querySelector(".post-card-image-link")
          postCardLink.href = post.url;

          // Access the links element within the temporary element
          const postCardLinkContent = tempElement.querySelector(".post-card-content-link")
          postCardLinkContent.href = post.url;

          // Access the title element within the temporary element
          const titleElement = tempElement.querySelector(".post-card-title");
          titleElement.innerHTML = post.title;

          // Access the post-primary-tag element within the temporary element
          const primaryTagElement = tempElement.querySelector(".post-primary-tag");
          if(post.primary_tag) {
            primaryTagElement.innerHTML = post.primary_tag.name;
            primaryTagElement.style.color = post.primary_tag.accent_color;
            primaryTagElement.style.borderColor = post.primary_tag.accent_color;
            primaryTagElement.classList.add(post.primary_tag.slug);
          }

          //if(post.primary_tag.slug != "sponsored") {
            //const tagNames = post.tags.map(tag => tag.name);
            //const hasTagStartingWithHash = tagNames.some(tagName => tagName.startsWith('#'));
            //if(hasTagStartingWithHash) {
              //const secondaryTagElement = tempElement.querySelector(".post-secondary-tag");
              //secondaryTagElement.classList.remove("hidden");
              // primaryTagElement.innerHTML = post.primary_tag.name;
            //}
          //}

          const tagNames = post.tags.map(tag => tag.name);
          const ifHasSponsored = tagNames.filter(tagName => tagName === 'Sponsored').length > 0;
          if(ifHasSponsored) {
            const secondaryTagElement = tempElement.querySelector(".post-secondary-tag");
            secondaryTagElement.classList.remove("hidden");
            // primaryTagElement.innerHTML = post.primary_tag.name;
          }

          // Access the date element within the temporary element
          const dateElement = tempElement.querySelector(".post-date");
          dateElement.innerHTML = formatDate(post.published_at);
                          
          // Access the read time element within the temporary element
          const readTimeElement = tempElement.querySelector(".card_read_time");
          readTimeElement.innerHTML = readTime;

          if(container) {
            container.innerHTML += tempElement.innerHTML;
          }
        }
      });

      cardHeightChecker();
    }

  function cardHeightChecker() {
    const cards = document.querySelectorAll("#related-content-container .post-card");
    cards.forEach((card) => {
      const titleHeight = card.querySelector('.post-card-title');
      var maxLines = 3;

      var truncateText = function(element, lines) {
        var lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
        var maxHeight = lines * lineHeight;
        var extraHeightForDots = 3;

        if (element.offsetHeight > 72) {
          element.setAttribute('data-tooltip', element.textContent);
          element.classList.add("tooltip-trigger");
          while (element.offsetHeight > maxHeight + extraHeightForDots) {
            element.textContent = element.textContent.trim().slice(0, -4);
          }

          element.textContent = element.textContent.trim() + '...';
        }

      };

      truncateText(titleHeight, maxLines);
    });
  }

    fetchRelatedPosts();

  // document.addEventListener('DOMContentLoaded', function() {
    
  //   const REQUEST_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

  //   const REQUEST_CONFIG = {
  //       method: 'HEAD',
  //       mode: 'no-cors'
  //   };

  //   const checkAdsBlocked = (callback) => {
  //     fetch(REQUEST_URL, REQUEST_CONFIG)
  //       .then((response) => {
  //           callback(response.redirected);  // ads are blocked if request is redirected
  //       })                                  // (we assume the REQUEST_URL doesn't use redirections)
  //       .catch(() => {
  //           callback(true);                 // ads are blocked if request fails
  //       });                                 // (we do not consider connction problems)
  //   };

  //   checkAdsBlocked((adsBlocked) => {
  //     if(adsBlocked){
  //       renderAds(postAdsList);
  //       // displayContentAd(false);
  //     } else {
  //       if(hasInternalTag){
  //         // displayContentAd(true);
  //       } else {
  //         renderAds(postAdsList);
  //         // displayContentAd(true);
  //       }
  //     }
  //   });
  // });

  //if (window.inArticleAdList && !window.inArticleAdListDisabled) {
  // function displayContentAd(displayGAM){
  //   const getSelectPostContent = document.querySelector('.post-content');
  //   const getSelectPostContentLength = parseInt(getSelectPostContent.children.length / 2);
  //   const getSelectPostContentItem = getSelectPostContent.children[getSelectPostContentLength];

  //   if(displayGAM){

  //     const newDiv = document.createElement('div');

  //     // Set attributes for the new div
  //     newDiv.id = 'div-gpt-ad-1709005345342-0';
  //     newDiv.style.minWidth = '580px';
  //     newDiv.style.minHeight = '400px';
  //     newDiv.style.marginBottom = '24px';
      
  //     // Create a new script element
  //     const newScript = document.createElement('script');
      
  //     // Set the script content
  //     newScript.textContent = "googletag.cmd.push(function() { googletag.display('div-gpt-ad-1709005345342-0'); });";

  //     // Append the script to the div
  //     newDiv.appendChild(newScript);

  //     getSelectPostContentItem.parentNode.insertBefore(newDiv, getSelectPostContentItem.nextSibling);
  //   } else {
      
  //     if (inArticleAdList) {
  //       const thisinPostAd = document.createElement('a');
  //       const thisinPostAdImage = document.createElement('img');
        
  //       thisinPostAd.classList.add('post-in-post-ad-custom');

  //       const getRandAdItem = inArticleAdList[Math.floor(Math.random() * inArticleAdList.length)];

  //       thisinPostAdImage.setAttribute('src', getRandAdItem.img);

  //       thisinPostAd.appendChild(thisinPostAdImage);
  //       //thisinPostAd.style.backgroundImage = 'url(' + getRandAdItem.img + ')';
  //       thisinPostAd.setAttribute('href', getRandAdItem.url);
  //       thisinPostAd.setAttribute('target', '_blank');

  //       getSelectPostContentItem.parentNode.insertBefore(thisinPostAd, getSelectPostContentItem.nextSibling);
  //     }
  //   }
  // }

  function isMobileDevice() {
    return window.matchMedia('(max-width: 500px)').matches;
  }

  if (isMobileDevice()) {
    document.addEventListener('DOMContentLoaded', initializeTooltipsAuthor);
  }

  // Define a function to initialize tooltips
  function initializeTooltipsAuthor() {
    // Get all elements with the 'tooltip-trigger' class
    const tooltipTriggers = document.querySelectorAll('.tooltip-trigger-author');
    // Iterate through each tooltip trigger
    tooltipTriggers.forEach(initializeTooltipAuthor);
  }

isTooltipOpen = false;

  // Define a function to initialize a single tooltip
  function initializeTooltipAuthor(trigger) {

    // Get the tooltip text from the 'data-tooltip' attribute
    const tooltipText = trigger.getAttribute('data-tooltip');

    // Create a new tooltip element
    const tooltip = document.createElement('span');
    tooltip.className = 'tooltip';
    tooltip.innerHTML = `<span class="tooltip-close"><img src="/assets/img/close-tooltip.svg"></span>${tooltipText}`;

    // Append the tooltip to the trigger's container
    trigger.appendChild(tooltip);

    trigger.addEventListener('click', function (event) {
      if(!isTooltipOpen){
        isTooltipOpen = true;
        showTooltipCustom(tooltip);
      }
    });

    const tooltipClose = document.querySelectorAll('.tooltip-close');

    tooltipClose.forEach((elem) => {
      elem.addEventListener('click', function(event) {
        hideTooltipCustom(tooltip);
        setTimeout(() => {
          isTooltipOpen = false;
        }, 100);
      });
    })
    
  }
  
  // Define a function to show the tooltip
  function showTooltipCustom(tooltip) {
    // Get the element by its class name
    const element = document.querySelector('.follow-us-on-linkedin');

    // Get the width of the element
    const width = element.offsetWidth;
    tooltip.style.width = `${width}px`;
    tooltip.classList.add('show');
  }

  // Define a function to hide the tooltip
  function hideTooltipCustom(tooltip) {
    tooltip.classList.remove('show');
  }

  function updateTooltipPosition(event, trigger, tooltip) {
    const xOffset = -8; // Adjust this value to set the horizontal offset
    const yOffset = 35; // Adjust this value to set the vertical offset

    const rect = trigger.getBoundingClientRect();

    const mouseX = event.clientX - rect.left + xOffset;
    const mouseY = event.clientY - rect.top + yOffset;

    tooltip.style.left = mouseX + 'px';
    tooltip.style.top = mouseY + 'px';
  }